import { tv } from 'tailwind-variants';

export const buttonStyles = tv({
  base: `rounded-xl font-medium disabled:opacity-40 cursor-pointer flex items-center justify-center gap-2`,
  variants: {
    size: {
      sm: 'h-8 text-xs px-2',
      md: 'h-10 text-sm px-4',
      lg: 'h-12 px-8',
    },
    variant: {
      primary:
        'bg-btn-primary text-btn-primary-text hover:bg-btn-primary-hover active:bg-btn-primary-active',
      ghost:
        'bg-btn-ghost text-btn-ghost-text hover:bg-btn-ghost-hover active:bg-btn-ghost-active',
      outline:
        'bg-btn-outline border-2 border-btn-outline-border text-btn-outline-text hover:bg-btn-outline-hover active:bg-btn-outline-active',
    },
    fullWidth: {
      true: 'w-full',
    },
  },
  defaultVariants: {
    size: 'md',
    fullWidth: false,
    variant: 'primary',
  },
});
